import {React, forwardRef} from 'react'


import '../components/HomeWork.css';



const HomeWork = forwardRef((props, ref) => {

  function handlePortfolioClickEvent (e)
  {
    e.currentTarget.querySelector('a').click();
  }

  const onImgLoad = ()=>
  {
    props.setImageCount(prev => prev +1)
  
  }




  return (
    <>
    
    <section className="work" ref={ref}>
      
      
        <div className="work-wrapper" >
          
            <div className="portfolio" onClick={handlePortfolioClickEvent}>
              <div className='content-top'>
                <div className='bullet'>Website UI/UX</div>
                <div className='bullet'>Website Development</div>
                <div className='bullet'>Blog</div>
              </div>
              <div className="content-bottom">
               
               
                <div className="brand">Company Connect</div>
                <a href="https://cctech.robustik.com" className='btn btn-native' target="_blank" aria-label="Check this out - Company Connect Project"><div>Check this out<i></i></div></a>
              </div>
              <img src="/assets/img/home/portfolio/1.webp" alt="Company Connect" width="100%" height="auto" onLoad={onImgLoad}/>
              
            </div>       
            <div className="portfolio" onClick={handlePortfolioClickEvent}>
              <div className='content-top'>
                <div className='bullet'>Website Development</div>
                <div className='bullet'>Motion Graphics</div>
              </div>
              <div className="content-bottom">
                <div className="brand">Seshaasai</div>
                <a href="https://seshaasai.com/" className='btn btn-native' target="_blank" aria-label="Check this out - Seshaasai Project"><div>Check this out<i></i></div></a>
              </div>
              <img src="/assets/img/home/portfolio/2.webp" alt="Seshaasai" width="100%" height="auto" onLoad={onImgLoad} />
            </div>      
            
            
            <div className="portfolio" onClick={handlePortfolioClickEvent}>
              <div className='content-top'>
                <div className='bullet'>Website Development</div>
              </div>
              <div className="content-bottom">
                <div className="brand">Plutos Payments</div>
                <a href="https://plutospayments.robustik.com/" className='btn btn-native' target="_blank"  aria-label="Check this out - Plutos Payment Project"><div>Check this out<i></i></div></a>
              </div>
              
              <img src="/assets/img/home/portfolio/3.webp" alt="Plutos Payments" width="100%" height="auto" onLoad={onImgLoad} />
            </div>

            <div className="portfolio">
              <div className='content-top'>
                <div className='bullet'>Brand Building</div>
              </div>
              <div className="content-bottom">
                <div className="brand">Mini Melons</div>
                <a href="" className='btn invisible' ><div>Check this out<i></i></div></a>
              </div>
              
              <img src="/assets/img/home/portfolio/4.webp" alt="Mini Melons" width="100%" height="auto" onLoad={onImgLoad} />
            </div>      
        </div>
    </section>
    </>
     
  );
});




export default HomeWork
